import { MessagePlusCircleIcon } from '@langchain/untitled-ui-icons';

import { PlaygroundCreatePromptButton } from '@/Pages/Prompts/components/PlaygroundButton';
import { usePermissions } from '@/hooks/usePermissions';
import { useSelectedTenant } from '@/hooks/useSwr';

export function NoData({ hasTags }: { hasTags?: boolean }) {
  const { data: tenant } = useSelectedTenant();
  const { authorize } = usePermissions();

  return (
    <div className="mx-auto mt-[100px] flex h-full flex-col gap-3 text-center">
      <div className="mx-auto flex h-[52px] w-[52px] items-center justify-center rounded-full bg-brand-green-25 bg-opacity-30 dark:bg-brand-green-400 dark:bg-opacity-20">
        <div className="flex h-10 w-10 items-center justify-center rounded-full bg-brand-green-25 text-brand-green-400 dark:bg-brand-green-400 dark:bg-opacity-40 dark:text-[#F7F6FF]">
          <MessagePlusCircleIcon />
        </div>
      </div>
      <span className="text-md font-medium">Start creating</span>
      <span className="text-sm text-ls-gray-600">
        {hasTags
          ? 'No matching prompts with current set of resource tags'
          : 'Create a prompt from scratch in the Playground'}
      </span>
      {authorize('prompts:create') && (
        <div className="mx-auto flex flex-row gap-2 pt-2">
          <PlaygroundCreatePromptButton
            organizationId={tenant?.id ?? undefined}
          />
        </div>
      )}
    </div>
  );
}
